export { m } from './bankOnboardingMessages'
